'use client';

import { TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { useTranslations } from 'next-intl';
import React from 'react';

import InfoTabItem from '@/app/[locale]/(default-layout)/info/_components/InfoTabItem';

import TabListLine from '@/components/misc/TabListLine';

import { getVideoAwareMarkdownComponents } from '@/helpers/video-aware-markdown-components-helper';

import CinemaDescriptionMarkdown from '@cineamo/ui/src/markdown/CinemaDescriptionMarkdown';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

export default function InfoTabs(): React.JSX.Element {
    const domainConfiguration = useDomainConfiguration();

    const t = useTranslations();

    const aboutPanel = (
        <TabPanel
            as="div"
            className="relative space-y-56 px-9 lg:px-0 pt-32 max-w-[780px]">
            <CinemaDescriptionMarkdown
                description={domainConfiguration.cinema.description}
                components={getVideoAwareMarkdownComponents(domainConfiguration, 'Cinema Description Video Played')}
            />
        </TabPanel>
    );

    return (
        <div>
            <TabGroup>
                <TabList
                    as="div"
                    className="relative w-full grid grid-flow-col justify-start text-button-16">
                    <InfoTabItem tabName={t('info.about')} />
                    <TabListLine />
                </TabList>
                <TabPanels>{aboutPanel}</TabPanels>
            </TabGroup>
        </div>
    );
}
